/**
 * Client country header name set by Imperva
 */
export const CLIENT_COUNTRY_HEADER = 'az-client-country';

export const AZ_COUNTRY_COOKIE = 'az-client-country';
